import React, {useState, useRef} from "react";
import { ProductInterface } from "../../interfaces/product/product.interface";
import { Option } from "./Option";
import { MiniInfo } from "./MiniInfo";
import ProductLabels from "./labels/Labels";

interface OptionsProps {
    product: ProductInterface;
}

export const Options: React.FC<OptionsProps> = ({ product }) => {
    
    const characteristicsRef = useRef<HTMLDivElement>(null);
    const [isShowCharacteristic, setIsShowCharacteristic] = useState(!product.description.length);
    const scrollToElementWithOffset = (element: HTMLElement, offset: number) => {
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
    };
    
    const showCharacteristic = () => {
        if (characteristicsRef.current) {
            scrollToElementWithOffset(characteristicsRef.current, 200);
            setIsShowCharacteristic(true);
        }
    };

    return (
        <div className="mt-3">
            <ProductLabels product={ product } />
            { product.options.map((option, i) => <Option key={ i } option={ option } />) }

             <div className="hidden md:block">
                <MiniInfo showCharacteristic={showCharacteristic} product={product} />
            </div>
        </div>
    )
}